import React from 'react';
import { Card, Table, Typography, Button, Space } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import reportsService from '@/services/reports.service';
import { formatDateTime } from '@/utils/format';

const { Title, Text } = Typography;

/** Phase 6: run/export audit log for reports platform */
export const ReportsAuditPage: React.FC = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['report-audit'],
    queryFn: () => reportsService.listAudit({ limit: 200 }),
  });

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: 8 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 12 }}>
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Report run audit
          </Title>
          <Text type="secondary">
            Who viewed, printed, exported, or scheduled reports. Back to{' '}
            <Link to="/reports">catalog</Link>.
          </Text>
        </div>
        <Button onClick={() => refetch()}>Refresh</Button>
      </Space>
      <Card size="small">
        <Table
          rowKey="id"
          loading={isLoading}
          dataSource={data || []}
          pagination={{ pageSize: 50 }}
          columns={[
            {
              title: 'When',
              dataIndex: 'created_at',
              width: 180,
              render: (v) => formatDateTime(v),
            },
            { title: 'Report', dataIndex: 'report_id', width: 220 },
            { title: 'Action', dataIndex: 'action', width: 100 },
            { title: 'Rows', dataIndex: 'row_count', width: 80 },
            { title: 'Format', dataIndex: 'export_format', width: 90 },
            { title: 'User', dataIndex: 'user_id', ellipsis: true },
          ]}
        />
      </Card>
    </div>
  );
};

export default ReportsAuditPage;
